const config = {
  CaptchaAppId: process.env.VUE_APP_CAPTCHA_APP_ID || '197368936',
  session_maxAge: Number(process.env.VUE_APP_SESSION_MAX_AGE) || 1000 * 60 * 120,
};

export default config;